export interface ICustomer {
  id: string;
  name: string;
}

/**
 * redux action type key
 */
export const enum CustomerActionKey {
  SetCustomers = 'Customer/SetCustomers'
}

/**
 * redux store
 */
export interface ICustomerStore {
  readonly customers: ICustomer[];
}



// WEBPACK FOOTER //
// ./src/modules/customers/parts/customer-type.ts